/** The home page: what needs attention today, the latest orders and the common actions. */
export const dashboard = {
    subtitle: "{{tenant}} · {{date}}",
    quickActions: "Quick actions",
    actions: {
        newOrder: "New order",
        addProduct: "Add product",
        adjustStock: "Adjust stock",
        recordPayment: "Record payment",
        posReview: "Review POS items",
    },
    attention: "Needs attention",
    onboarding: {
        title: "Get your business ready",
        progress: "{{completed}} of {{total}} done",
        trialEnds: "Trial ends {{date}}",
        skip: "Skip",
        dismiss: "Hide",
        open: "Open",
        loadSamples: "Load sample products",
        samplesLoaded: "{{count}} sample products added.",
        samplesExisting: "The sample products are already there.",
        done: "Done",
        skipped: "Skipped",
        steps: {
            business_profile: "Add your logo and address",
            products: "Import your products, or load sample products",
            courier: "Connect a courier",
            pos_device: "Pair a POS device",
            first_sale: "Make your first sale",
        },
    },
    tiles: {
        pendingOrders: "Orders to confirm",
        pendingOrdersHint: "Waiting for a call or confirmation",
        posReviews: "POS items to review",
        posReviewsHint: "Held or flagged while syncing",
        negativeStock: "Stock below zero",
        negativeStockHint: "Sold more than was on hand",
    },
    moreThan: "{{count}}+",
    sales: {
        title: "Sales",
        period: "Period",
        location: "Branch",
        allLocations: "All branches",
        periods: {
            today: "Today",
            yesterday: "Yesterday",
            last7: "Last 7 days",
            thisMonth: "This month",
            lastMonth: "Last month",
        },
        netSales: "Net sales",
        orders: "Orders",
        averageOrder: "Average order",
        grossProfit: "Gross profit",
        margin: "{{margin}} margin",
        change: "{{change}} vs previous period",
        noChange: "No sales in the previous period",
        chart: "Net sales by day",
        chartEmpty: "No sales in this period yet.",
        chartBar: "{{date}}: {{amount}} from {{orders}} orders",
        channels: "Channels",
        topProducts: "Top products",
        noProducts: "Nothing sold in this period.",
        qty: "Qty",
        amount: "Sales",
        lowStock: "Low or negative stock",
        lowStockHint: "{{negative}} below zero · {{low}} at or under reorder point",
        toShip: "Orders to ship",
        toShipHint: "{{pending}} still to confirm",
        codHeld: "COD with couriers",
        codHeldHint: "{{parcels}} delivered parcels not paid out",
        live: "Updates live",
        channelNames: {
            pos: "Counter (POS)",
            manual: "Manual",
            facebook: "Facebook",
            whatsapp: "WhatsApp",
            phone: "Phone",
            storefront: "Website",
        },
    },
    recentOrders: "Recent orders",
    viewAll: "View all",
    noOrders: "No orders yet",
    noOrdersBody: "Orders from the website, the phone and the counters will show up here.",
    columns: { number: "Order", customer: "Customer", status: "Status", total: "Total", when: "When" },
};
//# sourceMappingURL=dashboard.js.map